import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ServiceWorkerModule } from '@angular/service-worker';
import { SharedModule } from '@shared/shared.module';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { ApiInterceptor } from './interceptors/api-interceptor.service';
import { AuthInterceptorService } from './interceptors/auth-interceptor.service';
import { CreateExternalComponent } from './public/hid-actions/create-external/create-external.component';
import { TxViewComponent } from './public/tx-view/tx-view.component';

@NgModule({
    declarations: [
        AppComponent,
        CreateExternalComponent,
        TxViewComponent
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        SharedModule,
        ServiceWorkerModule.register('./notifications-worker.js', { registrationStrategy: 'registerWhenStable:30000' }),
        BrowserAnimationsModule,
    ],
    providers: [
        provideHttpClient(
            withFetch(),
            withInterceptorsFromDi()
        ),
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptorService,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        }
    ],
    bootstrap: [ AppComponent ]
})
export class AppModule { }
